module.exports = __webpack_public_path__ + "img/icon-store.52bb4d82.svg";